import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMatModule } from '../shared/app-mat.module';
import { SharedModule } from '../shared/shared.module';
import { SurveyListComponent } from './components/survey-list/survey-list.component';
import { ReportExportComponent } from './components/survey-reporting-dashboard/report-export/report-export.component';
import { SurveyReportingChartComponent } from './components/survey-reporting-dashboard/survey-reporting-chart/survey-reporting-chart.component';
import { SurveyReportingDashboardComponent } from './components/survey-reporting-dashboard/survey-reporting-dashboard.component';
import { SurveyReportingTableComponent } from './components/survey-reporting-dashboard/survey-reporting-table/survey-reporting-table.component';
import { SurveyAdminComponent } from './components/suvey-admin/survey-admin.component';
import { SurveyRoutingModule } from './survey-routing.module';

@NgModule({
  imports: [SurveyRoutingModule, AppMatModule, ReactiveFormsModule, FormsModule, CommonModule, SharedModule],
  declarations: [
    SurveyListComponent,
    SurveyReportingDashboardComponent,
    SurveyReportingChartComponent,
    ReportExportComponent,
    SurveyReportingTableComponent,
    SurveyAdminComponent,
  ],
  exports: [SurveyReportingChartComponent],
  providers: [],
})
export class SurveyModule {}
